import { gql } from '@apollo/client';

const TAGS_QUERY = gql`
    query tags {
        tags {
            edges {          
                node {
                    id
                    name
                    slug
                    metadata
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;

export default TAGS_QUERY;
